import { APP_CONFIG } from "../AppConfig";
import { BaseService } from "./baseService";

class ImageUploadService extends BaseService {
  async getResizedImage(key) {
    try {
      const responseData = await this.fetchData(
        `${APP_CONFIG.IMAGEUPLOAD_URL}/${key}/resized`,
        "GET"
      );
      return responseData;
    } catch (error) {
      console.error("Error fetching image:", error);
      const errorMessage = error.response
        ? error.response.data.message
        : "Unknown error occurred";
      throw new Error(errorMessage);
    }
  }
//   async getImage(key) {
//     try {
//       const responseData = await this.fetchData(
//         `${APP_CONFIG.IMAGEUPLOAD_URL}/${key}/upload`,
//         "GET"
//       );
//       return responseData;
//     } catch (error) {
//       console.error("Error fetching image:", error);
//       const errorMessage = error.response
//         ? error.response.data.message
//         : "Unknown error occurred";
//       throw new Error(errorMessage);
//     }
//   }

//   async imageUpload(formData) {
//     try {
//       const responseData = await this.fetchData(
//         `${APP_CONFIG.IMAGEUPLOAD_URL}/image-upload`,
//         "POST",
//         JSON.stringify(formData)
//       );
//       return responseData;
//     } catch (error) {
//       console.error("Error uploading image:", error);
//       const errorMessage = error.response
//         ? error.response.data.message
//         : "Unknown error occurred";
//       throw new Error(errorMessage);
//     }
//   }
}
export default ImageUploadService;
